import { render, staticRenderFns } from "./InputBoxplot.vue?vue&type=template&id=7845c342"
import script from "./InputBoxplot.vue?vue&type=script&lang=js"
export * from "./InputBoxplot.vue?vue&type=script&lang=js"
import style0 from "./InputBoxplot.vue?vue&type=style&index=0&id=7845c342&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports